import { Box, Button, Heading, Image, Text, VStack } from '@chakra-ui/react'
import { PilotCouncilConfig } from '../pilotTypes'

interface PilotIntroProps {
  config: PilotCouncilConfig
  onStart: () => void
}

const PilotIntro: React.FC<PilotIntroProps> = ({ config, onStart }) => {
  return (
    <VStack
      gap={{ base: 6, sm: 8 }}
      align="center"
      textAlign="center"
      maxW="560px"
      mx="auto"
      py={{ base: 8, sm: 12 }}
      px={{ base: 4, sm: 6 }}
    >
      {config.logoUrl && (
        <Image src={config.logoUrl} alt={config.displayName} maxH="72px" objectFit="contain" />
      )}

      <VStack gap={3}>
        <Heading size={{ base: 'xl', sm: '2xl' }} color="gray.800" lineHeight="1.2">
          {config.introHeadline}
        </Heading>
        <Text fontSize={{ base: 'md', sm: 'lg' }} color="gray.600" lineHeight="1.6">
          {config.introBody}
        </Text>
      </VStack>

      <Box
        w="full"
        bg="white"
        borderRadius="xl"
        p={{ base: 4, sm: 6 }}
        boxShadow="sm"
        border="1px solid"
        borderColor="gray.200"
      >
        <VStack gap={3} align="stretch">
          {[
            { step: '1', label: 'Enter your home address' },
            { step: '2', label: 'We assess your retrofit potential' },
            { step: '3', label: 'See your savings, costs & available grants' },
            { step: '4', label: 'Book a free consultation' },
          ].map(({ step, label }) => (
            <Box key={step} display="flex" alignItems="center" gap={3}>
              <Box
                w="28px" h="28px" borderRadius="full" bg="brand.500" flexShrink={0}
                display="flex" alignItems="center" justifyContent="center"
              >
                <Text color="white" fontSize="sm" fontWeight="bold">{step}</Text>
              </Box>
              <Text fontSize="sm" color="gray.700">{label}</Text>
            </Box>
          ))}
        </VStack>
      </Box>

      <Button
        size="lg"
        bg="brand.500"
        color="white"
        _hover={{ opacity: 0.9 }}
        onClick={onStart}
        w="full"
        maxW="320px"
        py={6}
        fontSize="md"
        whiteSpace="normal"
        lineHeight="1.3"
      >
        Get my free assessment →
      </Button>

      <Text fontSize="xs" color="gray.400">
        Free to use · No account required
        <br />
        Provided by Greenflip, in partnership with {config.displayName}{config.partnerName && ` and ${config.partnerName}`}
      </Text>
    </VStack>
  )
}

export default PilotIntro
